import { IonContent, IonFooter, IonPage, useIonViewWillEnter } from '@ionic/react'
import styled from 'styled-components'
import {
  CustomSpacer,
  FooterButtons,
  PagingContentReverse,
  StyleIonHeader,
  StyleIonInputValue,
  TextStyle,
} from '../../../components'
import { useContext, useEffect, useRef, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import { VALIDATE_STATUS } from '../../../common'

type Props = RouteComponentProps<{
  qnaId: string
}>

export const QnaDetail: React.FC<Props> = observer(({ match }) => {
  const { myStore } = useContext(StoresContext)
  const element = useRef<HTMLDivElement>(document.createElement('div'))
  const [chat, setChat] = useState<string>('')
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS>(VALIDATE_STATUS.INPUT)
  const pagingStore = myStore.qnaDetailPagingStore
  let loadParam = { qnaId: Number(match.params.qnaId) }

  useIonViewWillEnter(() => {
    setTimeout(() => {
      element.current?.scrollIntoView({ block: 'end', behavior: 'smooth' })
    }, 300)
  })

  useEffect(() => {
    loadParam = { qnaId: Number(match.params.qnaId) }
    pagingStore.load({ param: loadParam }, true)
  }, [match.params.qnaId])

  const onInputChat = (chat: string | number) => {
    setChat(String(chat))
  }

  useEffect(() => {
    validate()
  }, [chat])

  const validate = () => {
    if (chat != undefined && chat?.length > 0) {
      setValidateStatus(VALIDATE_STATUS.OKAY)
    } else {
      setValidateStatus(VALIDATE_STATUS.INPUT)
    }
  }

  const onRegisterQnaChats = async () => {
    await myStore.registerQnaChats(Number(match.params.qnaId), chat)
    location.reload()
  }

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'1:1 문의내역'} href={'/myPage/qna'} />
      <IonContent>
        <TitleContainer>
          <TextStyle type={'b_16'}>문의 제목</TextStyle>
          <CustomSpacer spacing="8px" />
          <TitleWrap>
            <TextStyle type={'b_14'}>유저가 이전에 입력했던 문의 제목 들어갑니다.</TextStyle>
          </TitleWrap>
        </TitleContainer>
        <ListBackground>
          <SubTitleWrap>
            <TextStyle type={'b_16'}>문의 내용</TextStyle>
          </SubTitleWrap>
          <ListContainer ref={element}>
            <CustomSpacer spacing="24px" />
            <PagingContentReverse pagingStore={pagingStore} loadParam={{ param: loadParam }}>
              {pagingStore.list
                .slice()
                .reverse()
                .map((d, i) => (
                  <ListWrap key={i}>
                    {d.isMine ? (
                      <RightWrap>
                        <ItemRightContainer>
                          <ContentRightWrap>
                            <TextStyle type={'r_14'} color={'primary_dark'}>
                              {d.content ?? '-'}
                            </TextStyle>
                          </ContentRightWrap>
                          <DateWrap>
                            <TextStyle type={'r_11'}>{moment(new Date(d.createdDate)).format('YYYY/MM/DD')}</TextStyle>
                          </DateWrap>
                        </ItemRightContainer>
                      </RightWrap>
                    ) : (
                      <LeftWrap>
                        <ItemLeftContainer>
                          <ContentLeftWrap>
                            <TextStyle type={'r_14'} color={'white'}>
                              {d.content ?? '-'}
                            </TextStyle>
                          </ContentLeftWrap>
                          <ContentLeftDateWrap>
                            <TextStyle type={'r_11'}>{moment(new Date(d.createdDate)).format('YYYY/MM/DD')}</TextStyle>
                          </ContentLeftDateWrap>
                        </ItemLeftContainer>
                      </LeftWrap>
                    )}
                  </ListWrap>
                ))}
            </PagingContentReverse>
          </ListContainer>
        </ListBackground>
      </IonContent>
      <IonFooter>
        <IonInputWrap>
          <StyleIonInputValue
            type={'text'}
            inputmode={'text'}
            inputType={'INPUT'}
            placeholder={'추가 문의사항을 입력해주세요.'}
            onInput={onInputChat}
            value={chat}
          />
        </IonInputWrap>
      </IonFooter>
      <FooterButtons
        button={{
          color: 'dark',
          text: '추가 문의 보내기',
          onClick: () => onRegisterQnaChats(),
          disabled: validateStatus !== VALIDATE_STATUS.OKAY ? true : false,
        }}
      />
    </IonPage>
  )
})

const TitleContainer = styled.div`
  padding: 25px 20px;
  position: fixed;
  left: 0;
  right: 0;
  background-color: var(--ion-color-white);
  border-bottom: solid 1px var(--ion-color-gray100);
`
const TitleWrap = styled.div`
  width: 100%;
  border-radius: 4px;
  padding: 11.5px 8px;
  background-color: var(--ion-color-gray100);
`
const ListBackground = styled.div`
  min-height: 100%;
  background-color: var(--ion-color-gray100);
`
const SubTitleWrap = styled.div`
  margin-top: 125px;
  padding: 25px 20px 16px 20px;
  background-color: var(--ion-color-white);
`

const ListContainer = styled.div`
  padding: 0 20px;
`
const ListWrap = styled.div`
  display: flex;
  flex-direction: column-reverse;
`

const RightWrap = styled.div`
  float: right;
`

const LeftWrap = styled.div`
  float: left;
`

const ItemRightContainer = styled.div`
  display: flex;
  float: right;
  flex-direction: column;
  max-width: 85%;
  margin-top: 24px;
`

const DateWrap = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 8px;
`

const ContentRightWrap = styled.div`
  background-color: var(--ion-color-white);
  border-radius: 4px;
  padding: 8px;
`

const ItemLeftContainer = styled.div`
  display: flex;
  float: left;
  flex-direction: column;
  max-width: 85%;
  margin-top: 24px;
`

const ContentLeftDateWrap = styled.div`
  margin-bottom: 8px;
`

const ContentLeftWrap = styled.div`
  background-color: var(--ion-color-primary_dark);
  border-radius: 4px;
  padding: 8px;
`

const IonInputWrap = styled.div`
  padding: 8px 20px;
`
